import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { ChakraProvider, theme } from "@chakra-ui/react";
import { MapProvider } from "./contexts/MapContext";

ReactDOM.render(
  <React.StrictMode>
    <MapProvider>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
    </MapProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
